export const formatSearchChipDate = (value) => String(value || '').trim().replace(/-/g, '/');

export const buildToolbarFilterChips = (
  entries = [],
  {
    onClearAll = null,
    clearLabel = 'クリア',
    clearAriaLabel = '検索条件をすべてクリア',
  } = {}
) => {
  const chips = entries.flatMap((entry) => {
    const key = String(entry?.key || '').trim();
    const label = String(entry?.label || '').trim();
    const value = String(entry?.value || '').trim();
    if (!key || !label || !value) return [];
    return [
      {
        key,
        text: `${label}: ${value}`,
        onRemove: typeof entry?.onRemove === 'function' ? entry.onRemove : null,
        ariaLabel: String(entry?.ariaLabel || `${label}: ${value} を解除`).trim(),
        variant: 'filter',
      },
    ];
  });

  if (chips.length > 0 && typeof onClearAll === 'function') {
    chips.push({
      key: '__clear_all__',
      text: String(clearLabel || 'クリア').trim() || 'クリア',
      onRemove: onClearAll,
      ariaLabel: String(clearAriaLabel || '検索条件をすべてクリア').trim() || '検索条件をすべてクリア',
      variant: 'clear-all',
    });
  }

  return chips;
};
